/**
 * Skeleton de chargement pour le visualiseur de documents
 */
const DocumentViewerSkeleton = () => {
  return (
    <div className="flex flex-col shadow border rounded-md p-6 space-y-6">
      <div className="flex items-center space-x-4">
        <div className="h-20 w-20 skeleton-bar"></div>
        <div className="flex-1 space-y-3">
          <div className="h-5 w-1/3 skeleton-bar"></div>
          <div className="h-4 w-1/4 skeleton-bar"></div>
        </div>
      </div>

      <div className="space-y-2">
        <div className="h-4 w-1/5 skeleton-bar"></div>
        <div className="h-3 w-2/3 skeleton-bar"></div>
        <div className="h-3 w-3/4 skeleton-bar"></div>
        <div className="h-3 w-1/2 skeleton-bar"></div>
      </div>

      <div className="space-y-2">
        <div className="h-4 w-1/4 skeleton-bar"></div>
        <div className="h-3 w-2/3 skeleton-bar"></div>
        <div className="h-3 w-3/4 skeleton-bar"></div>
        <div className="h-3 w-1/2 skeleton-bar"></div>
      </div>

      <div className="space-y-2">
        <div className="h-4 w-1/4 skeleton-bar"></div>
        <div className="h-3 w-2/3 skeleton-bar"></div>
        <div className="h-3 w-3/4 skeleton-bar"></div>
        <div className="h-3 w-1/2 skeleton-bar"></div>
      </div>

      <div className="space-y-2">
        <div className="h-4 w-1/4 skeleton-bar"></div>
        <div className="h-3 w-2/3 skeleton-bar"></div>
        <div className="h-3 w-3/4 skeleton-bar"></div>
      </div>

      <div className="space-y-2">
        <div className="h-4 w-1/4 skeleton-bar"></div>
        <div className="grid grid-cols-2 gap-2">
          <div className="h-3 w-3/4 skeleton-bar"></div>
          <div className="h-3 w-2/3 skeleton-bar"></div>
          <div className="h-3 w-1/2 skeleton-bar"></div>
          <div className="h-3 w-2/5 skeleton-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default DocumentViewerSkeleton;
